import { authService } from '../services/auth';

/**
 * Helper to get authenticated headers for API requests
 * Usage: const headers = await getAuthHeaders();
 *        fetch('/api/jobs', { headers });
 */
export const API_BASE = import.meta.env.VITE_API_BASE || '/api';

export const getAuthHeaders = async () => {
  const session = await authService.getSession();
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': session?.access_token ? `Bearer ${session.access_token}` : '',
  };

  return headers;
};